import { PdfTemplateSection } from "@/modules/TemplatePdf/Models/sectionsPdf";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ActionPlan,
  ConfigInputs,
  GrupoInfoInput,
  InfoInput
} from "../../models/ActionPlan.model";

@Component({
  name: "PreviewActionPlan"
})
export default class PreviewActionPlan extends Vue {
  @Prop() objActionPlan!: ActionPlan;
  @Prop() pdfSections!: PdfTemplateSection[];

  get headers() {
    return this.objActionPlan.config?.header.groupInputs ?? [];
  }

  get sections() {
    return this.objActionPlan.config?.sections ?? [];
  }

  getFomula(input: InfoInput, section?: string) {
    let valor = "";
    if (input.type == "boolean") {
      valor = `$(${input.inputName})`;
      return valor;
    }
    input.formula.forEach(element => {
      if (element.type == "string") {
        valor += element.name;
        return;
      }

      const sectionLocal =
        section && element.type != "variable" ? section + " ~ " : "";

      valor += `$(${sectionLocal}${element.type} ~ ${element.name} ~ ${element.field?.title})`;
    });
    return valor.trim();
  }

  getGroupInputs(configInputs: ConfigInputs, name: string): GrupoInfoInput {
    const grupoInfoInput = configInputs.groupInputs.find(
      x => x.typeRow == name
    );
    if (!grupoInfoInput) {
      return { inputs: [] };
    }
    return grupoInfoInput;
  }

  getLabels(configInputs: ConfigInputs): GrupoInfoInput {
    return this.getGroupInputs(configInputs, "labels");
  }

  getSintomas(configInputs: ConfigInputs): GrupoInfoInput {
    return this.getGroupInputs(configInputs, "sintomas");
  }

  getTabla(configInputs: ConfigInputs): GrupoInfoInput {
    return this.getGroupInputs(configInputs, "tabla");
  }
  getRecomendaciones(configInputs: ConfigInputs): GrupoInfoInput {
    return this.getGroupInputs(configInputs, "recomendaciones");
  }
}
